const strategiesTreeModelConfig = {
  fontSize: 12,
  lineHeight: 1.3,
};

export default strategiesTreeModelConfig;
